// Runs a callback once the DOM is ready, without jQuery. This bundle is loaded
// with `defer`, so the DOM is already parsed by the time it executes; the guard
// is only a safety net if the loading strategy ever changes.
function onReady(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

onReady(function() {
  const images = document.querySelectorAll('.js-lazy-image');
  const config = {
    // If the image gets within 50px in the Y axis, start the download.
    rootMargin: '50px 0px',
    threshold: 0.01
  };

  let imageCount = images.length;
  let observer;

// If we don't have support for intersection observer, loads the images immediately
  if (!('IntersectionObserver' in window)) {
    loadImagesImmediately(images);
  } else {
    // It is supported, load the images
    observer = new IntersectionObserver(onIntersection, config);

    // foreach() is not supported in IE
    for (let i = 0; i < images.length; i++) {
      let image = images[i];
      if (image.classList.contains('js-lazy-image--handled')) {
        continue;
      }

      observer.observe(image);
    }
  }

  /**
   * Fetchs the image for the given URL
   * @param {string} url
   */
  function fetchImage(url) {
    return new Promise(function(resolve, reject) {
      const image = new Image();
      image.src = url;
      image.onload = resolve;
      image.onerror = reject;
    });
  }

  /**
   * Preloads the image
   * @param {object} image
   */
  function preloadImage(image) {
    let src = image.dataset.src;
    if (!src) {
      return;
    }

    try {
      var supportsWebP = sessionStorage.getItem('canUseWebP');
      if(supportsWebP == null) {
        sessionStorage.setItem('canUseWebP', canUseWebP());
        supportsWebP = sessionStorage.getItem('canUseWebP');
      }
    }
    catch (error) {
      supportsWebP = canUseWebP();
    }

    let not_webp = image.getAttribute('data-no-webp') !== undefined && image.getAttribute('data-no-webp') === "1"
    let src_split = image.getAttribute('data-src').split('.')
    let ext = src_split[src_split.length - 1];
    if (supportsWebP === 'true' && !src.includes('?') && !not_webp && (ext !== 'svg' && ext !== 'gif')) {
      src += ".webp";
    }

    return fetchImage(src).then(function() {
      applyImage(image, src);
    }).catch(function() {
      src = src.replace('\.webp', '');
      applyImage(image, src);
    });
  }

  /**
   * Load all of the images immediately
   * @param {NodeListOf<Element>} images
   */
  function loadImagesImmediately(images) {
    // foreach() is not supported in IE
    for (let i = 0; i < images.length; i++) {
      let image = images[i];
      preloadImage(image);
    }
  }

  /**
   * Disconnect the observer
   */
  function disconnect() {
    if (!observer) {
      return;
    }

    observer.disconnect();
  }

  /**
   * On intersection
   * @param {array} entries
   */
  function onIntersection(entries) {
    // Disconnect if we've already loaded all of the images
    if (imageCount === 0) {
      observer.disconnect();
    }

    // Loop through the entries
    for (let i = 0; i < entries.length; i++) {
      let entry = entries[i];
      // Are we in viewport?
      if (entry.intersectionRatio > 0) {
        imageCount--;

        // Stop watching and load the image
        observer.unobserve(entry.target);
        preloadImage(entry.target);
      }
    }
  }

  /**
   * Apply the image
   * @param {object} img
   * @param {string} src
   */
  function applyImage(img, src) {
    // Prevent this from being lazy loaded a second time.
    img.classList.add('js-lazy-image--handled');
    img.src = src;
    img.classList.add('fade-in');
  }


  function canUseWebP() {
    let elem = document.createElement('canvas');
    let browser= get_browser();
    if (browser.name === 'Firefox' && parseInt(browser.version) > 64)
      return true;
    if (!!(elem.getContext && elem.getContext('2d'))) {
      // was able or not to get WebP representation
      return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    // very old browser like IE 8, canvas not supported
    return false;
  }

  function get_browser() {
    let ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
      tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
      return {name:'IE',version:(tem[1]||'')};
    }
    if(M[1]==='Chrome'){
      tem=ua.match(/\bOPR|Edge\/(\d+)/)
      if(tem!=null)   {return {name:'Opera', version:tem[1]};}
    }
    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
    return {
      name: M[0],
      version: M[1]
    };
  }
});
